const meta = (name: string, fallback: string) =>
  typeof document === 'undefined'
    ? fallback
    : (document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`)?.content ?? fallback);

export const production = meta('cairn-mode', 'local') === 'production';
export const logoutCookieDomain = meta('cairn-logout-cookie-domain', '');

export function logoutEpoch() {
  return typeof document === 'undefined'
    ? ''
    : (document.cookie
        .split('; ')
        .find(c => c.startsWith('cairn-logout='))
        ?.slice('cairn-logout='.length) ?? '');
}

export function advanceLogoutEpoch() {
  if (typeof document === 'undefined') {
    return;
  }

  const domain = logoutCookieDomain ? `; Domain=${logoutCookieDomain}` : '';

  // biome-ignore lint/suspicious/noDocumentCookie: the logout marker is a plain cookie readable by every window; the Cookie Store API is unavailable on Safari
  document.cookie = `cairn-logout=${crypto.randomUUID()}; Path=/; Max-Age=31536000; SameSite=Lax${domain}${location.protocol === 'https:' ? '; Secure' : ''}`;
}
